var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 120,
    viewBox: "0 0 92 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0478 39.081C54.6031 39.081 51 35.3782 51 30.8107V14.2702C51 9.70271 54.6031 6 59.0478 6H82.0414C86.486 6 90.0891 9.70271 90.0891 14.2702V30.8107C90.0891 35.3782 86.486 39.081 82.0414 39.081H69.6023L59.9094 49.2307C59.5979 49.5569 59.0478 49.3364 59.0478 48.8854V39.081Z",
    stroke: "#008CFF",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4929 18.8126V18.787C67.5698 16.9163 68.6717 16.0195 70.3117 16.0195C71.9774 16.0195 73.1305 16.942 73.1305 18.9664C73.1305 20.0683 72.4387 20.9396 71.7468 21.5546L70.4142 22.7846C69.1586 23.9634 68.8511 24.5015 68.8511 25.6803V26.244H71.5418V25.9365C71.5418 25.3472 71.7211 25.1165 72.3362 24.5271L73.6687 23.2971C74.8731 22.1952 75.8212 20.6833 75.8212 18.9151C75.8212 14.5332 72.618 13.4313 70.3117 13.4313C68.0311 13.4313 64.8791 14.5588 64.8022 18.787V18.8126H67.4929ZM68.4923 31.6254H71.9261V28.1916H68.4923V31.6254Z",
    fill: "#B9BFC6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 61,
    width: 33,
    height: 54,
    rx: 7,
    stroke: "#B9BFC6",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.75,
    y: 66.75,
    width: 4.55263,
    height: 4.55263,
    rx: 1.25,
    stroke: "#B9BFC6",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.75,
    y: 75.2236,
    width: 4.55263,
    height: 4.55263,
    rx: 1.25,
    stroke: "#B9BFC6",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21.75,
    y: 83.6973,
    width: 4.55263,
    height: 4.55263,
    rx: 1.25,
    stroke: "#B9BFC6",
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30.2246,
    y: 66.75,
    width: 4.55263,
    height: 4.55263,
    rx: 1.25,
    stroke: "#B9BFC6",
    strokeWidth: 1.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 30.2246,
    y: 75.2236,
    width: 4.55263,
    height: 4.55263,
    rx: 1.25,
    stroke: "#B9BFC6",
    strokeWidth: 1.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 30.2246,
    y: 83.6973,
    width: 4.55263,
    height: 4.55263,
    rx: 1.25,
    stroke: "#B9BFC6",
    strokeWidth: 1.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 38.6973,
    y: 66.75,
    width: 4.55263,
    height: 4.55263,
    rx: 1.25,
    stroke: "#B9BFC6",
    strokeWidth: 1.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 38.6973,
    y: 75.2236,
    width: 4.55263,
    height: 4.55263,
    rx: 1.25,
    stroke: "#B9BFC6",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/EmptyCart.ce5ec8379448f0dd1ba9b37895b94cf9.svg";
export { ForwardRef as ReactComponent };